export const PRIVACY_POLICY_LINK = "documents/bunkey_privacy_policy.pdf";

export const USAGE_TERMS_LINK = "../documents/bunkey_usage_terms.pdf";

export const USAGE_TERMS_LINK_FROM_HOME = "../documents/bunkey_usage_terms.pdf";